import React from 'react';
import Footer from '../Footer';
import berendezkedesIcon from '../../img/berendezkedes.png';
import elhelyezesIcon from '../../img/elhelyezes.png';
import hazirendIcon from '../../img/hazirend.png';
import intezmenyIcon from '../../img/intezmeny.png';
import latogatasIcon from '../../img/latogatas.png';
import './styles/SubInfoPage.css';

const SectionTitle = ({ icon, alt, children }) => (
  <h4 className="content-icon-heading">
    <img src={icon} alt={alt} className="content-heading-icon" />
    <span>{children}</span>
  </h4>
);

const MovingInPage = () => {
  return (
    <div className="sub-info-page">
      <section className="sub-info-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">A beköltözésről</h2>
            <p className="section-subtitle">
              Beköltözés feltételei és információk
            </p>
          </div>

          <div className="content-card">
            <h3>Beköltözés feltételei</h3>
            <div className="content-body">
              <p>Az intézmény nyitott idősek otthona. Az intézménybe felvételt nyerhetnek mindazok, akik saját jogú nyugellátásban részesülnek, gondozási szükségletük meghaladja a napi 4 órát vagy már betöltötték a 80. életévüket, és állapotuk nem igényel rendszeres gyógyintézeti kezelést, napi szintű orvosi felügyeletet.</p>
              
              <div className="warning-section">
                <SectionTitle icon={intezmenyIcon} alt="">Kizáró okok:</SectionTitle>
                <ul>
                  <li>24 órás orvosi felügyelet szükségessége</li>
                  <li>az ön- és közveszélyes pszichés állapot</li>
                  <li>a közösséget zavaró szenvedélybetegség</li>
                </ul>
              </div>
              
              <p><strong>Fontos:</strong> A fokozott gondozást biztosító részlegünkön elsősorban az intézmény általános gondozási részlegén élőknek biztosítunk állapotromlás esetén férőhelyet. Ebből kifolyólag ápolást, gondozást igénylő új kérelmező elhelyezésére csak abban az esetben van lehetőség, amennyiben az aktuálisan üres férőhely intézményen belülről nem vár betöltésre, így a fokozott gondozást biztosító részlegre a várakozási idő nem meghatározható.</p>
              
              <SectionTitle icon={elhelyezesIcon} alt="">Elhelyezési folyamat</SectionTitle>
              <p>Az intézményi elhelyezést a hatályos jogszabályok alapján – írásban vagy szóban – kell kérelmeznie az igénylőknek. A kérelem pozitív elbírálását követően a férőhely elfoglalását megelőzően, de legkésőbb azzal egyidejűleg a fenntartó képviselője az 1993. évi III. törvény és végrehajtási rendeleteiben foglaltak alkalmazásával az ellátást igénybe vevővel megállapodást köt.</p>
              
              <SectionTitle icon={berendezkedesIcon} alt="">Berendezés</SectionTitle>
              <p>Otthonunkban mindenki saját bútoraival rendezheti be a lakrészét az általános gondozási szinteken, a fokozott gondozást biztosító részlegeken az apartmanok funkcionálisan berendezettek, kisebb bútorok, személyes tárgyak helyezhetők el csupán – előzetes megbeszélés, egyeztetés szerint.</p>
              
              <SectionTitle icon={hazirendIcon} alt="">Házirend</SectionTitle>
              <p>A mindennapos együttélés alapvető szabályait az intézményi Házirend részletezi, amiről minden beköltözőt a megállapodás megkötésével egyidejűleg tájékoztatunk.</p>
              
              <SectionTitle icon={latogatasIcon} alt="">Látogatók</SectionTitle>
              <p>Az intézmény minden lakója fogadhat látogatókat a lakrészében vagy a közösségi helyiségekben a társas együttélés szabályaira és az intézményi Házirendben foglaltakra tekintettel. Előzetes egyeztetés után kisebb családi összejöveteleiket is megtarthatják nálunk az arra kijelölt helységben.</p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default MovingInPage;
